export const getPaymentMethodName = (paymentMethod) => {
  if (paymentMethod?.flag?.name) {
    return `${paymentMethod.name} (${paymentMethod.flag.name})`;
  }

  return paymentMethod.name;
};
